import { render, staticRenderFns } from "./UserHoliday.vue?vue&type=template&id=6991a400"
import script from "./UserHoliday.js?vue&type=script&lang=js&external"
export * from "./UserHoliday.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports